var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-0d2c839d-1a55-4b1a-ad50-f4c08acf6dde",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-2e21dc08-1975-4134-bd8c-e1b35252f3ec {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2e21dc08-1975-4134-bd8c-e1b35252f3ec",
    d: "M14.84,21.82c-.27,0-.53-.11-.72-.3-.02-.02-2.13-2.19-3.21-3.15-.41-.37-.45-1-.08-1.41.37-.41,1-.45,1.41-.08.63.57,1.57,1.49,2.29,2.21.98-2.07,3-6.07,5.12-8.55.36-.42.99-.47,1.41-.11.42.36.47.99.11,1.41-2.7,3.17-5.39,9.32-5.42,9.38-.13.31-.41.53-.74.58-.06.01-.12.02-.18.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.0c53d8bc3eed5cb3a9e12341044c3b6d.svg";
export { ForwardRef as ReactComponent };